import { BONUS_BALANCE } from 'shared/constants/common';
import { getBalanceDetails } from 'shared/util/utility';
import { CouponState, PlaceBet } from '../interface';

export const getAnalyticalData = (couponState: CouponState, lastElement?: boolean) => {
	const { selectedBalanceType, bonusBalance, mainBalance } = getBalanceDetails();

	const getBetPromo = (isFreeBetSelected: boolean, bonusBet: boolean) => {
		if (isFreeBetSelected) return 'freeBet';
		else if (bonusBet) return 'bonus';
		else return 'cash';
	};

	const checkBetType = (outcomes: PlaceBet[]) => {
		const hasLive = outcomes.some((outcome) => outcome.isLive);
		const hasPrematch = outcomes.some((outcome) => !outcome.isLive);

		if (hasLive && hasPrematch) {
			return 'mixed';
		} else if (hasLive) {
			return 'live';
		} else {
			return 'prematch';
		}
	};

	const balance_before_coupon = mainBalance + bonusBalance;
	const balance_after_coupon = mainBalance + bonusBalance - couponState.bets.stake;
	const bet_balance_type = getBetPromo(couponState.bets.isFreeBetSelected, couponState.bets.bonusBet);
	const event_id = couponState.bets?.outcomes.map((el: PlaceBet) => el.eventId);
	const participants = couponState.bets?.outcomes.map((el: PlaceBet) => el.eventName);
	const event_category_1 = couponState.bets?.outcomes.map((el: PlaceBet) => el.sportId);
	const event_category_2 = couponState.bets?.outcomes.map((el: PlaceBet) => el.categoryId);
	const bet_selected_1 = couponState.bets?.outcomes.map((el: PlaceBet) => el.gameId);
	const bet_selected_2 = couponState.bets?.outcomes.map((el: PlaceBet) => el.outcomeId);
	const bet_odds = couponState.bets?.outcomes.map((el: PlaceBet) => el.outcomeOdds);
	const bet_live = couponState.bets?.outcomes.map((el: PlaceBet) => el.isLive);
	const bet_bonus_balance = selectedBalanceType === BONUS_BALANCE ? bonusBalance : null;

	const getValue = (values: any) => {
		if (lastElement) return values[values.length - 1];
		else return values;
	};

	return {
		balance_before_coupon,
		balance_after_coupon,
		bet_balance_type,
		bet_bonus_balance,
		coupon_type: checkBetType(couponState.bets?.outcomes),
		event_id: getValue(event_id),
		participants: getValue(participants),
		event_category_1: getValue(event_category_1),
		event_category_2: getValue(event_category_2),
		bet_selected_1: getValue(bet_selected_1),
		bet_selected_2: getValue(bet_selected_2),
		outcome_url: window.location.pathname,
		outcome_from_homepage: window.location.pathname === '/zaklady-bukmacherskie',
		bet_odds: getValue(bet_odds),
		total_odds: Number(
			couponState.bets?.outcomes.reduce((acc: any, item: any) => (item.selectedBet ? acc * item.outcomeOdds : acc), 1).toFixed(2),
		),
		bet_promo: bet_balance_type,
		bet_type: couponState.bets.betMode,
		bet_live: getValue(bet_live),
		bet_potential_win: couponState?.betStatics?.newPossibleWinning?.totalWinning ?? 0,
	};
};
